export type ListNavigationKey = "j" | "k" | "arrowdown" | "arrowup" | "home" | "end";

export function nextTaskIndex(current: number, length: number, key: ListNavigationKey): number {
  if (length <= 0) return -1;
  if (key === "home") return 0;
  if (key === "end") return length - 1;
  if (key === "j" || key === "arrowdown") return Math.min(length - 1, current + 1);
  return Math.max(0, current < 0 ? length - 1 : current - 1);
}

export function showTaskContextBar(count: number, searched: boolean, filtered: boolean, groupCount: number): boolean {
  return count >= 20 || searched || filtered || groupCount >= 3;
}
